module.exports = __webpack_public_path__ + "assets/images/project/icon/type.svg?v=faa14be8";